// @flow
import {tree} from '../StripeClui/generated_tree';
import type {Commands} from '../StripeClui/helpers/commands/resource';

const CHAIN_DELIMITER = ' ';

export const getResources = () => {
  const resources = tree.root?.commands?.stripe.commands || {};
  return resources;
};

// Given a command, recursively search through its subcommands to determine the end of the resource chain.
// Example: [issuing, card_holders], [issuing, authorizations]
// There is no practical case where a sub resource has a subresource but just in case this should.
const getResourceChains = (commands: any): Array<Array<string>> => {
  const resourceChains = [];
  Object.entries(commands).forEach(([name, command]: [string, any]) => {
    // If the subcommands are actions, Skip them
    if (!command.path) {
      const subResources = getResourceChains(command.commands || {});
      if (subResources.length === 0) {
        // We've reached the end of the resource chain
        resourceChains.push([name]);
      } else {
        subResources.forEach((subResource) => {
          resourceChains.push([name].concat(subResource));
        });
      }
    }
  });

  return resourceChains;
};

// Returns an array of resource chains which as space separated.
export const getFlattenedResourceNames = (
  resources: Commands,
  ignoredResources: Array<string>,
): Array<string> => {
  // The first iteration is special because we want to specifically avoid some top level commands
  const resourceChains = getResourceChains(resources);
  const resourceNames = resourceChains
    .map((chain) => chain.join(CHAIN_DELIMITER))
    .filter((resourceName) => !ignoredResources.includes(resourceName));
  return resourceNames;
};

export const lookUpResourceByName = (
  resources: Commands,
  resourceName: string,
): Commands => {
  if (!resourceName) {
    return {};
  }

  const resourceChain = resourceName.split(CHAIN_DELIMITER);
  let commands = resources;
  for (const resource of resourceChain) {
    if (!commands[resource]?.commands) {
      // If at any point we cannot find the command, return {}
      return {};
    }
    commands = commands[resource].commands;
  }

  return commands;
};
